import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  NgModule,
  ModuleWithProviders,
  ErrorHandler,
  Optional,
  SkipSelf,
  APP_INITIALIZER,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HttpClient } from '@angular/common/http';

// Components
import { SortableColumnService } from './components';

// Confirmation

// Plugins
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Modules
import { LanguageModule } from './language';
import { NotificationModule } from './notification';
import { ApiModule } from './api';
import { AuthenticationModule } from './authentication';
import { CacheModule } from './cache';

// Extensions
import './extensions/array.extension';
import './extensions/date.extension';

// Constants
import './constants/api.translations';

// EnvironmentService
import { EnvironmentService } from './services/environment.service';

import { ValidationService } from './services/validation.service';
import { SlugService } from './services/slug.service';
import { CoreService } from './services/core.service';

import { GlobalErrorHandler } from './services/error.hanlder';
import { throwIfAlreadyLoaded } from './module-import.guard';
import { HeaderService } from './api/services/header.service';

// This function makes the i18n.json load
// Must be an export function (AOT)
// @dynamic
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// This function loads the runtime configuration
// Must be an export function (AOT)
// @dynamic
export function appInitializerFn(environmentService: EnvironmentService) {
  return () => {
    return environmentService.loadEnvironment();
  };
}
// @dynamic
@NgModule({
  imports: [
    // assets
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule,

    // Plugins
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      progressBar: true,
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      /* with HTTP
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader
      }*/
    }),

    // Modules
    LanguageModule,
    NotificationModule,
    ApiModule,
    AuthenticationModule,
    CacheModule,
    // ConfirmationModule,
    // PermissionModule
  ],
  exports: [
    // Assets
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule,

    // Plugins
    ToastrModule,
    TranslateModule,
    NgbModule,

    // Features
    // ConfirmationModule,
    AuthenticationModule,
    // PermissionModule
  ],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: appInitializerFn,
          multi: true,
          deps: [EnvironmentService],
        },
        SlugService,
        CoreService,
        ValidationService,
        EnvironmentService,
        HeaderService,
        SortableColumnService,
        {
          provide: ErrorHandler,
          useClass: GlobalErrorHandler,
          deps: [EnvironmentService],
        },
      ],
    };
  }
}
